import { useCallback } from 'react';
import { DropdownItem } from 'ui-components';
import { EditIcon } from 'ui-components/dist/EditIcon';
import { FEATURE_FLAGS } from '~/constants';
import { useFeatureFlag } from '~/hooks/useFeatureFlag';
import { useEditCreatorStore } from '~/screens/MyAgency/store';
import { ICreator } from '~/types';

interface IEditInfoDropdownItem {
  creator: ICreator;
}

export const EditInfoDropdownItem: React.FC<IEditInfoDropdownItem> = ({
  creator,
}) => {
  const { openEditModal, openEditDrawer } = useEditCreatorStore();

  const isFoamUnverifiedToVerified =
    useFeatureFlag(FEATURE_FLAGS.foamUnverifiedToVerified) === 'enabled';

  const onEditClick = useCallback(
    (e: React.MouseEvent) => {
      e.stopPropagation();

      if (isFoamUnverifiedToVerified) {
        openEditModal(creator);
        return;
      }

      openEditDrawer(creator);
    },
    [creator, isFoamUnverifiedToVerified, openEditModal, openEditDrawer],
  );

  return (
    <DropdownItem onClick={onEditClick} trackId="foam-talent-menu-edit-info">
      <EditIcon boxSize={4} />
      Edit Info
    </DropdownItem>
  );
};
